import * as Sentry from '@sentry/nextjs';

import { DeviceCheckResult } from '~/generated/graphql';
import getOsInfo from '~/helpers/deviceChecks/getOsInfo';
import { DeviceCheckMetadata } from '~/types';

const compareVersions = (
  expectedVersion: string,
  actualVersion: string,
): boolean => {
  const expectedVersionParts = expectedVersion.split('.');
  const actualVersionParts = actualVersion.split('.');
  const checkLength = Math.min(
    expectedVersionParts.length,
    actualVersionParts.length,
  );
  let pass: boolean = false;

  // eslint-disable-next-line no-loops/no-loops, no-plusplus
  for (let i = 0; i < checkLength; i++) {
    const expectedVersionSegment = parseInt(expectedVersionParts[i], 10);
    const actualVersionSegment = parseInt(actualVersionParts[i], 10);

    if (expectedVersionSegment < actualVersionSegment) {
      pass = true;
      break;
    } else if (expectedVersionSegment > actualVersionSegment) {
      pass = false;
      break;
    }
    pass = true;
  }

  return pass;
};

const checkMinOsVersion: DeviceCheckMetadata['check'] = async ({
  expectedValue,
  registrationDetails,
}) => {
  // throw new Error('This is a test error on Min OS version');
  try {
    if (!expectedValue) {
      throw new Error('Expected value not provided');
    }

    const osInfo = await getOsInfo(navigator.userAgent, registrationDetails);

    if (!osInfo?.version) {
      return {
        expectedValue,
        result: DeviceCheckResult.Fail,
      };
    }

    if (compareVersions(expectedValue, osInfo.version)) {
      return {
        expectedValue,
        result: DeviceCheckResult.Pass,
        value: osInfo.version,
      };
    }
    return {
      expectedValue,
      result: DeviceCheckResult.Fail,
      value: osInfo.version,
    };
  } catch (err) {
    const error = new Error(
      JSON.stringify({
        error: String(err),
        registrationDetails,
      }),
    );

    Sentry.captureException(error);
    return {
      result: DeviceCheckResult.Fail,
    };
  }
};

export default checkMinOsVersion;
